// Elements matching these selectors have Vue components mounted inside them
// (see SubscribeFormProvider.vue). We need to prevent nanomorph from morphing
// them, otherwise the mounted components get destroyed.
//
// Nanomorph checks `newNode.isSameNode(oldNode)` - if it returns true, the
// element is skipped entirely. We patch `isSameNode` on the NEW document
// before morphing since that's what nanomorph calls the method on.
//
// This is best-effort: adjacent content changes can still cause nanomorph to
// destroy these elements. SubscribeFormProvider handles that by detecting
// dead apps (!el.isConnected) and remounting.
const NO_MORPH_SELECTORS = [".subscribe-form", "#subscribe-form"];

// We use nodeType instead of instanceof because the node comes from the
// iframe's document, where Element is a different constructor than ours.
const isElementNode = (node: Node): node is Element => {
  return node.nodeType === Node.ELEMENT_NODE;
};

export const patchNoMorphElements = (newDoc: Document) => {
  for (const selector of NO_MORPH_SELECTORS) {
    for (const elem of newDoc.querySelectorAll(selector)) {
      (elem as any).isSameNode = (other: Node) => {
        return isElementNode(other) && other.matches(selector);
      };
    }
  }
};
